import DollarBadge from 'components/Svgs/DollarBadge'

export const FloatingBadge = () => {
  return <DollarBadge height={24} width={24} />
}
